import Blue from '~/core';
import { debounce } from '../utils';

new Blue({
  name: 'Search Landing',
  selector: '.home-search',
  setup(searchLanding) {
    const searchResults = searchLanding.dataset.endpoint;
    const searchInput = searchLanding.querySelector('#home-search-field');
    const searchOutputContainer = searchLanding.querySelector(
      '#home-search-results'
    );
    const searchOutput = searchOutputContainer.querySelector(
      '.returned-results'
    );
    let searchText;

    const inputHandler = debounce(processInput);

    this.$addEvents(searchInput, 'input', () => {
      searchOutputContainer.style.display = 'block';
      searchOutput.innerHTML = '';
      searchText = searchInput.value.toLowerCase();
    });
    this.$addEvents(searchInput, 'input', inputHandler);

    this.$addEvents(document, 'click', e => {
      if (
        e.target !== searchOutputContainer &&
        !searchOutputContainer.contains(e.target)
      ) {
        searchOutputContainer.style.display = 'none';
      }
    });

    async function processInput() {
      const doSearch = searchText => {
        return new Promise(async resolve => {
          const response = await fetch(searchResults, {
            method: 'POST',
            body: JSON.stringify({ searchText }),
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            resolve(response.json());
          } else {
            resolve(false);
          }
        });
      };

      if (searchText.length && searchText.length >= 2) {
        const data = await doSearch(searchText);
        if (data) {
          if (data.resultsExist) {
            renderResults(data);
          } else {
            searchOutput.innerHTML = 'No results found.';
          }
        }
      } else if (!searchText.length) {
        searchOutputContainer.style.display = 'none';
        searchOutput.innerHTML = '';
      }
    }

    const renderResults = ({ markets, universities, properties }) => {
      const generateMarkup = (markets, universities, properties) => `
				<div class="results-headers">
					<div class="ul">
						<h4>City</h4>
					</div>
					<div class="ul">
						<h4>University</h4>
					</div>
					<div class="ul">
						<h4>Community</h4>
					</div>
				</div>
				<div class="response">
					<div class="ul">
						<ul>
							${markets}
						</ul>
					</div>
					<div class="ul">
						<ul>
							${universities}
						</ul>
					</div>
					<div class="ul">
						<ul>
							${properties}
						</ul>
					</div>
				</div>`;

      const generateItems = items => {
        return items.reduce((_items, item) => {
          console.log(item.url);
          _items += `
						<li>
							<a href="${item.url.replace("student-apartments/nj/princeton/merwick-stanworth", "faculty-housing/nj/princeton/merwick-stanworth")}" target="_blank">${item.name}</a>
						</li>`;
          return _items;
        }, '');
      };

      searchOutput.innerHTML = generateMarkup(
        generateItems(markets),
        generateItems(universities),
        generateItems(properties)
      );
    };
  },
});
